import { render, staticRenderFns } from "./MultiselectProducerProductCategories.vue?vue&type=template&id=a72e1e7a"
import script from "./MultiselectProducerProductCategories.vue?vue&type=script&lang=js"
export * from "./MultiselectProducerProductCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports